import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import Logo from "./Logo";

const MAIN_SITE = "https://francescaspinazzola.it";

const QUICK_LINKS = [
  { label: "Chi Sono", href: `${MAIN_SITE}/#chi-sono` },
  { label: "Servizi", href: `${MAIN_SITE}/servizi-extra` },
  { label: "I Miei Lavori", href: `${MAIN_SITE}/portfolio` },
  { label: "Blog", href: `${MAIN_SITE}/blog` },
  { label: "Contatti", href: `${MAIN_SITE}/#contatti` },
  { label: "Newsletter", href: `${MAIN_SITE}/#contatti` },
];

const SOCIALS = [
  { icon: Instagram, href: "https://www.instagram.com/francescaspinazzola/", label: "Instagram" },
  { icon: Facebook, href: "https://www.facebook.com/francesca.spinazzola/", label: "Facebook" },
  { icon: Youtube, href: "https://www.youtube.com/@francescaspinazzola", label: "YouTube" },
];

const Footer = () => {
  const isAnchor = (href) => href.startsWith("#");

  const handleAnchor = (e, href) => {
    if (!isAnchor(href)) return;
    e.preventDefault();
    const el = document.getElementById(href.slice(1));
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div>
          <Logo className="footer-logo" />
          <p className="footer-tag">
            Home Staging Emozionale per il settore turistico. Progetto spazi che
            accolgono, emozionano e creano connessione — perché il risultato
            migliore nasce dal cuore.
          </p>
        </div>

        <div>
          <h4 className="footer-heading">Link Rapidi</h4>
          <div className="footer-links">
            {QUICK_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                target={isAnchor(l.href) ? undefined : "_blank"}
                rel={isAnchor(l.href) ? undefined : "noopener noreferrer"}
                onClick={(e) => handleAnchor(e, l.href)}
              >
                {l.label}
              </a>
            ))}
            <Link to="/prodotti" className="footer-reserved" style={{ color: "#e9ddd0" }}>
              I nostri strumenti
            </Link>
            <Link to="/area-riservata" className="footer-reserved">
              Area riservata
            </Link>
          </div>
        </div>

        <div>
          <h4 className="footer-heading">Social</h4>
          <div className="social-row">
            {SOCIALS.map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                className="social-btn"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
              >
                <Icon size={18} strokeWidth={1.6} />
              </a>
            ))}
          </div>
          <p className="footer-company">Oasi del Silenzio Srls</p>
          <p className="footer-address">
            Contrada San Pietro snc
            <br />
            83035 Grottaminarda (AV)
          </p>
          <p className="footer-vat">P.IVA 02862030646 | SDI M5UXCR1</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Oasi del Silenzio Srls. Tutti i diritti riservati.</p>
        <div className="footer-legal">
          <a href={`${MAIN_SITE}/privacy-policy`} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          <span>·</span>
          <a href={`${MAIN_SITE}/cookie-policy`} target="_blank" rel="noopener noreferrer">
            Cookie Policy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
